<template>
	<transition name="flip" mode="out-in">
		<div v-if="!flipped" key="front" class="card" :class="[type, { 'empty-card': !show || dragged, bounce }]" :style="cardStyle" ref="card" @dblclick="flip">
			<!-- {'opacity-0': !show || dragged} -->
			<div v-if="show && !dragged" class="card-body front">

				<span class="card-title">{{ cardText('title') }}</span>
				<span v-if="hasFrontText" class="card-subtitle mt-1 d-block">{{ cardText('front') }}</span>
				<span v-if="type == 'chemistry'" class="card-subtitle mt-1 d-block" v-html="cardText('formula')"></span>

				<img v-if="image" :src='getImage(image)' class="pointer-events-none" style="margin: auto; width: 40%; margin: 0em 0 0;">

				<!-- <span class="double-click">{{ $t('double_click') }}</span> -->
			</div>

			<ExploreButton v-if="show && !dragged" :cardValue="cardValue" @click="readMore" />
		</div>
		<div v-else key="back" class="card" :class="{ [type]: true, 'empty-card': !show || dragged, bounce }" @dblclick="flip">
			<div v-if="show && !dragged" class="card-body back">

				<h6 class="card-title">{{ cardText('title') }}</h6>
				<div class="card-scrollable">
					<span v-if="type == 'reservoir'" class="card-subtitle">{{ cardText('front') }}</span>
					<span class="card-text">{{ cardText('back') }}</span>
				</div>
			</div>
		</div>
	</transition>
	<!-- <div v-else class="card empty-card"> -->
	<!-- </div> -->
</template>



<script>
import ExploreButton from '@/components/ExploreButton.vue';

export default {
	props: [ "type", "cardId", "cardValue", "image", "cardHeight", "hasFrontText" ],
	components: { ExploreButton },
	data() {
		return {
			show: true,
			flipped: false,
			dragged: false,

			bounce: false,
			bounceTimeout: null,
		};
	},
	methods: {
		getImage(path) {
			return require('@/assets/' + path);
		},
		cardText(key) {
			const phrase = `card_${this.cardValue}_${key}`;
			if (this.$te(phrase)) {
				return this.$t(phrase);
			}
		},
		flip() {
			// if (this.show) {
			// 	this.flipped = !this.flipped;
			// 	this.$log.onCardFlip(this.cardValue, this.flipped);
			// 	this.$tracker.onCardFlip(this.cardValue, this.flipped);
			// }
		},
		place() {
			this.show = false;
			this.dragged = false;
		},
		clear() {
			this.show = true;
			this.dragged = false;
			this.playBounce();
		},

		playBounce() {
			this.bounce = false;
			clearTimeout(this.bounceTimeout);
			setTimeout(() => {
				this.bounce = true;
				this.bounceTimeout = setTimeout(() => {
					this.bounce = false;
				}, 800);
			}, 50);
		},

		readMore() {
			this.$emit('readMore', this.rect, this.type, this.cardValue);
		},
	},
	computed: {
		rect() {
			return this.$refs.card.getBoundingClientRect();
		},
		cardStyle() {
			return {
				minHeight: this.cardHeight,
			};
		},
	},
	watch: {
		dragged() {
			if (this.show) {
				// this.playBounce();
			}
		}
	}
};
</script>



<style scoped>
	.card {
		width: 100%;
		border-radius: 0.5em;
		padding: 0.25em;
		user-select: none;
		box-shadow: 1px 4px 4px rgba(0, 0, 0, 0.3);

		font-size: 0.9em;
		line-height: 1.2em;

		/*cursor: grab;*/
		cursor: pointer;
		transition: all .05s ease-out;
	}

	.card:hover {
		opacity: 0.8;
	}
	.card:active {
		cursor: grabbing;
	}

	.empty-card {
		background: rgba(0, 0, 0, 0);
		/*box-shadow: unset;*/
		box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.3);
		/*border: unset;*/
	}

	.card-body {
		padding: 0.5em;
		border: 1px solid white;
		border-radius: calc(0.5em - 0.25em);

		display: -webkit-box;
		flex-direction: column;
		justify-content: center;
		overflow: auto;
	}

	.card-title {
		font-weight: bold;
		font-size: 1.2em;
	}

	.card-subtitle {
	}
	.card-text {
		/*overflow-y: auto;*/
	}

	.double-click {
		color: #444;
		font-size: 0.7em;
		position: absolute;
		bottom: 0.7em;
		right: 1.2em;
	}


	.front {
		color: white;
		font-size: 1.0em;
		text-align: center;
	}
	.back {
		background-color: white;
		font-size: 0.9em;
		text-align: left;
	}
	.back .card-scrollable {
		display: flex;
		flex-direction: column;
		overflow-y: auto;
	}
	.back .card-subtitle {
		/*margin-top: -0.5em;*/
		margin-bottom: 0.7em;
	}


	/* Flip animation */

	/* End of flip */
	.flip-enter-active {
		transition: all 0.4s cubic-bezier(0.250, 0.460, 0.450, 0.940);
	}
	.flip-enter {
		transform: perspective(700px) rotateY(90deg) translateY(-10px);
		box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.3);
	}

	/* Start of flip */
	.flip-leave-active {
		transition: all 0.4s cubic-bezier(0.550, 0.085, 0.680, 0.530);
	}
	.flip-leave-active {
		transform: perspective(700px) rotateY(-90deg) translateY(-10px);
	}

	/* Shared props */
	.flip-enter, .flip-leave-active {
		box-shadow: 0px 10px 40px rgba(1, 0, 0, 0.1);
	}


	.bounce {
		animation: Bounce .6s ease-out;
	}
	@keyframes Bounce {
		0%	{ transform: scale(1.10); }
		25%	{ transform: scale(0.95); }
		50%	{ transform: scale(1.02); }
		75%	{ transform: scale(0.99); }
		100%{ transform: scale(1.00); }
	}
</style>
